import Web3 from 'web3'
import BigNumber from 'bignumber.js'
import { Contracts } from './lib/contracts.js'
import { Account } from './lib/accounts.js'
import { EVM } from './lib/evm.js'

import { contractAddresses, deadAddress } from './lib/constants'

export class Sushi {
  constructor(provider, networkId, testing, options) {
    let realProvider

    if (typeof provider === 'string') {
      if (provider.includes('wss')) {
        realProvider = new Web3.providers.WebsocketProvider(provider, options.ethereumNodeTimeout || 10000)
      } else {
        realProvider = new Web3.providers.HttpProvider(provider, options.ethereumNodeTimeout || 10000)
      }
    } else {
      realProvider = provider
    }

    this.web3 = new Web3(realProvider)

    if (testing) {
      this.testing = new EVM(realProvider)
      this.snapshot = this.testing.snapshot()
    }

    if (options.defaultAccount) {
      this.web3.eth.defaultAccount = options.defaultAccount
    }
    this.provider = realProvider
    this.networkId = networkId
    this.contracts = new Contracts(realProvider, networkId, this.web3, options)
    this.sushiAddress = contractAddresses.sushi[networkId]
    this.masterChefAddress = contractAddresses.masterChef[networkId]
    this.wethAddress = contractAddresses.weth[networkId]
    this.bakeDestroyedAddress = contractAddresses.bakeDestroyed[networkId]
    this.bakeDestroyedManagerAddress = contractAddresses.bakeDestroyedManager[networkId]
    this.deadAddress = deadAddress
    this.dishAddress = contractAddresses.dish[networkId]
    this.dishMasterAddress = contractAddresses.dishMaster[networkId]
    this.dishStakingPowerTokenAddress = contractAddresses.dishStakingPowerToken[networkId]
    this.exchangeNFTAddress = contractAddresses.exchangeNFT[networkId]
    this.bidDishNFTAddress = contractAddresses.bidDishNFT[networkId]
    this.petAddress = contractAddresses.pet[networkId]
    this.petMasterAddress = contractAddresses.petMaster[networkId]
    this.petMaster2Address = contractAddresses.petMaster2[networkId]
    this.petEggNftAddress = contractAddresses.petEggNft[networkId]
    this.exchangeEggNFTAddress = contractAddresses.exchangeEggNFT[networkId]
    this.bidPetEggNFTAddress = contractAddresses.bidPetEggNFT[networkId]
    this.exchangeArtworkNFTAddress = contractAddresses.exchangeArtworkNFT[networkId]
    this.bidDigitalArtworkNFTAddress = contractAddresses.bidDigitalArtworkNFT[networkId]
    this.weaponAddress = contractAddresses.weapon[networkId]
    this.weaponMasterAddress = contractAddresses.weaponMaster[networkId]
    this.weaponNFTAddress = contractAddresses.weaponNFT[networkId]
    this.exchangeWeaponNFTAddress = contractAddresses.exchangeWeaponNFT[networkId]
    this.bidWeaponNFTAddress = contractAddresses.bidWeaponNFT[networkId]
    this.binanceNftAddress = contractAddresses.binanceNft[networkId]
    this.exchangeBinanceNftAddress = contractAddresses.exchangeBinanceNft[networkId]
    this.bidBinanceNFTAddress = contractAddresses.bidBinanceNFT[networkId]
    this.transferAddress = contractAddresses.transfer[networkId]
    this.bestTokenAddress = contractAddresses.bestToken[networkId]
    this.bestMasterAddress = contractAddresses.bestMaster[networkId]
    this.bakeryArtworkNFTAddress = contractAddresses.bakeryArtworkNFT[networkId]
    this.digitalArtworkNFTAddress = contractAddresses.digitalArtworkNft[networkId]
    this.exchangeBakeryArtworkNFTAddress = contractAddresses.exchangeBakeryArtworkNFT[networkId]
    this.bidBakeryArtworkNFTAddress = contractAddresses.bidBakeryArtworkNFT[networkId]
    this.bakeryArtworkRouterAddress = contractAddresses.bakeryArtworkRouter[networkId]
    this.reviewAddress = contractAddresses.reviewAddress[networkId]
    this.weaponNFTCommonMasterAddress = contractAddresses.weaponNFTCommonMaster[networkId]
    this.petNFTCommonMasterAddress = contractAddresses.petNFTCommonMaster[networkId]
    this.petNftAddress = contractAddresses.petNft[networkId]
    this.exchangePetNftAddress = contractAddresses.exchangePetNft[networkId]
    this.bidPetNFTAddress = contractAddresses.bidPetNFT[networkId]
    this.bakeryArtwork2NFTAddress = contractAddresses.bakeryArtwork2NFT[networkId]
    this.exchangeBakeryArtwork2NFTAddress = contractAddresses.exchangeBakeryArtwork2NFT[networkId]
    this.bidBakeryArtwork2NFTAddress = contractAddresses.bidBakeryArtwork2NFT[networkId]
    this.dogeMemeNFTAddress = contractAddresses.dogeMemeNFT[networkId]
    this.exchangeDogeMemeNFTAddress = contractAddresses.exchangeDogeMemeNFT[networkId]
    this.bidDogeMemeNFTAddress = contractAddresses.bidDogeMemeNFT[networkId]
    this.helmetNftAddress = contractAddresses.helmetNft[networkId]
    this.helmetNftCommonMasterAddress = contractAddresses.helmetNftCommonMaster[networkId]
    this.eth2MasterAddress = contractAddresses.eth2Master[networkId]
    this.tenAddress = contractAddresses.ten[networkId]
    this.tenMasterAddress = contractAddresses.tenMaster[networkId]
    this.tenPetNftMasterAddress = contractAddresses.tenPetNftMaster[networkId]
    this.tenBakeBLPAddress = contractAddresses.tenBakeBLP[networkId]
    this.wSOTEAddress = contractAddresses.wSOTE[networkId]
    this.wSOTEMasterAddress = contractAddresses.wSOTEMaster[networkId]
    this.wSoteBakeBLPAddress = contractAddresses.wSoteBakeBLP[networkId]
    this.SHIELDAddress = contractAddresses.SHIELD[networkId]
    this.SHIELDMasterAddress = contractAddresses.SHIELDMaster[networkId]
    this.BRYAddress = contractAddresses.BRY[networkId]
    this.BRYMasterAddress = contractAddresses.BRYMaster[networkId]
    this.BRYBakeBLPAddress = contractAddresses.BRYBakeBLP[networkId]
    this.aethAddress = contractAddresses.aeth[networkId]
    this.ankrAddress = contractAddresses.ankr[networkId]
    this.onxAddress = contractAddresses.onx[networkId]
    this.aethMasterAddress = contractAddresses.aethMaster[networkId]
    this.bakeryArtwork3NFTAddress = contractAddresses.bakeryArtwork3NFT[networkId]
    this.exchangeBakeryArtwork3NFTAddress = contractAddresses.exchangeBakeryArtwork3NFT[networkId]
    this.bidBakeryArtwork3NFTAddress = contractAddresses.bidBakeryArtwork3NFT[networkId]
    this.bananaAddress = contractAddresses.BANANA[networkId]
    this.bananaMasterAddress = contractAddresses.BANANAMaster[networkId]
    this.bakeBananaBlpAddress = contractAddresses.bakeBananaBlp[networkId]
    this.seascapeNFTAddress = contractAddresses.seascapeNFT[networkId]
    this.seascapeCommonNftMasterAddress = contractAddresses.seascapeCommonNftMaster[networkId]
    this.exchangeSeascapeNFTAddress = contractAddresses.exchangeSeascapeNFT[networkId]
    this.bidSeascapeNFTAddress = contractAddresses.bidSeascapeNFT[networkId]
    this.pCWSBnbBlpAddress = contractAddresses.pCWSBnbBlp[networkId]
    this.pCWSBakeBlpAddress = contractAddresses.pCWSBakeBlp[networkId]
    this.pCWSAddress = contractAddresses.pCWS[networkId]
    this.pCWSMasterAddress = contractAddresses.pCWSMaster[networkId]
    this.spartanBakeBaseIDOAddress = contractAddresses.spartanBakeBaseIDO[networkId]
    this.crudeoilBakeBaseIDOAddress = contractAddresses.crudeoilBakeBaseIDO[networkId]
    this.soccerBakeBaseIDOAddress = contractAddresses.soccerBakeBaseIDO[networkId]
    this.busdAddress = contractAddresses.busdToken[networkId]
    this.usdtAddress = contractAddresses.usdtToken[networkId]
    this.warAddress = contractAddresses.war[networkId]
    this.bakeWarBlpAddress = contractAddresses.bakeWarBlp[networkId]
    this.warMasterAddress = contractAddresses.warMaster[networkId]
    this.voteForNFTAddress = contractAddresses.voteForNFT[networkId]
    this.warMaster2Address = contractAddresses.warMaster2[networkId]
    this.tokocryptoNftAddress = contractAddresses.tokocryptoNft[networkId]
    this.tokocryptoCommonNftMasterAddress = contractAddresses.tokocryptoCommonNftMaster[networkId]
    this.exchangeTokocryptoNFTAddress = contractAddresses.exchangeTokocryptoNFT[networkId]
    this.bidTokocryptoNFTAddress = contractAddresses.bidTokocryptoNFT[networkId]
    this.oneInchBakeNFTAddress = contractAddresses.oneInchBakeNFT[networkId]
    this.exchangeOneInchBakeNFTAddress = contractAddresses.exchangeOneInchBakeNFT[networkId]
    this.bidOneInchBakeNFTAddress = contractAddresses.bidOneInchBakeNFT[networkId]
    this.mxAddress = contractAddresses.mx[networkId]
    this.bakeMxBlpAddress = contractAddresses.bakeMxBlp[networkId]
    this.mxMasterAddress = contractAddresses.mxMaster[networkId]
    this.aliceAddress = contractAddresses.alice[networkId]
    this.aliceMasterAddress = contractAddresses.aliceMaster[networkId]
    this.bakeAliceBlpAddress = contractAddresses.bakeAliceBlp[networkId]
    this.aliceNftAddress = contractAddresses.aliceNft[networkId]
    this.aliceCommonNftMasterAddress = contractAddresses.aliceCommonNftMaster[networkId]
    this.autoBnbBlpAddress = contractAddresses.autoBnbBlp[networkId]
    this.soccerAddress = contractAddresses.soccer[networkId]
    this.soccerBakeBlpAddress = contractAddresses.soccerBakeBlp[networkId]
    this.bakerySoccerAddress = contractAddresses.bakerySoccer[networkId]
    this.bakerySoccerMasterAddress = contractAddresses.bakerySoccerMaster[networkId]
    this.exchangeBakerySoccerAddress = contractAddresses.exchangeBakerySoccer[networkId]
    this.bidBakerySoccerAddress = contractAddresses.bidBakerySoccer[networkId]
    this.bakerySoccerStakingPowerTokenAddress = contractAddresses.bakerySoccerStakingPowerToken[networkId]
    this.tctAddress = contractAddresses.tct[networkId]
    this.tctBusdBlpAddress = contractAddresses.tctBusdBlp[networkId]
    this.tctMasterAddress = contractAddresses.tctMaster[networkId]
    this.dfyMasterAddress = contractAddresses.dfyMaster[networkId]
    this.gamyfiBakeBaseIdoAddress = contractAddresses.gamyfiBakeBaseIdo[networkId]
    this.sfpNFTAddress = contractAddresses.sfpNFT[networkId]
    this.sfpAddress = contractAddresses.sfp[networkId]
    this.exchangeSfpNFTAddress = contractAddresses.exchangeSfpNFT[networkId]
    this.bidSfpNFTAddress = contractAddresses.bidSfpNFT[networkId]
    this.pokerAddress = contractAddresses.poker[networkId]
    this.mintAddress = contractAddresses.mintAddress[networkId]
  }

  async resetEVM() {
    this.testing.resetEVM(this.snapshot)
  }

  addAccount(address, number) {
    this.accounts.push(new Account(this.contracts, address, number))
  }

  setProvider(provider, networkId) {
    this.web3.setProvider(provider)
    this.contracts.setProvider(provider, networkId)
    this.operation.setNetworkId(networkId)
  }

  setDefaultAccount(account) {
    this.web3.eth.defaultAccount = account
    this.contracts.setDefaultAccount(account)
  }

  getDefaultAccount() {
    return this.web3.eth.defaultAccount
  }

  loadAccount(account) {
    const newAccount = this.web3.eth.accounts.wallet.add(account.privateKey)

    if (!newAccount || (account.address && account.address.toLowerCase() !== newAccount.address.toLowerCase())) {
      throw new Error(`Loaded account address mismatch.
        Expected ${account.address}, got ${newAccount ? newAccount.address : null}`)
    }
  }

  toBigN(a) {
    return BigNumber(a)
  }
}
